/* eslint-disable class-methods-use-this */
const _emptyArray = Object.freeze([]);
const _emptyObject = Object.freeze({});
const _emptyString = Object.freeze('');

class Empty {
    static get Array() {
        return _emptyArray;
    }

    static get Object() {
        return _emptyObject;
    }

    static get String() {
        return _emptyString;
    }
}

module.exports = Empty;
